/* CHUNK 1: Data and Configuration */
console.log("✅ rug-customizer.js file is included!");

// Global variable to store the current organization key
let currentOrgKey = "";

// Organizations object (each org appears only once, sorted alphabetically)
const organizations = {
  "alpha-chi-omega": {
    name: "Alpha Chi Omega",
    logos: [
      { name: "AXO Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_Letters_RED.png?v=1741552620" },
      { name: "AXO Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_Letters_BLK.png?v=1741552621" },
      { name: "AXO Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_Letters_WHT.png?v=1741552621" },
      { name: "AXO Primary Logo (Vertical)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_PrimaryLogo_Vertical.png?v=1741552621" },
      { name: "AXO Primary Logo (Horizontal)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_PrimaryLogo_Horizontal.png?v=1741552621" },
      { name: "AXO Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AXO_CoA_Color.png?v=1741552621" }
    ],
    colors: [
      { name: "Scarlet", code: "#C81E3C" },
      { name: "Olive", code: "#7B933D" },
      { name: "Olympus", code: "#BDC3D8" },
      { name: "Vega", code: "#31758A" },
      { name: "Iris", code: "#7D6EAC" },
      { name: "Hera", code: "#F0D1D6" },
      { name: "Lyre", code: "#FBCBC3" },
      { name: "Greencastle", code: "#8B957B" },
      { name: "Ebony", code: "#3D3C3A" },
      { name: "Chord", code: "#B6B7BA" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "alpha-delta-pi": {
    name: "Alpha Delta Pi",
    logos: [
      { name: "ADP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Letters_WHT.png?v=1741556234" },
      { name: "ADP Letters Azure", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Letters_Azure.png?v=1741556234" },
      { name: "ADP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Letters_BLK.png?v=1741556234" },
      { name: "ADP Primary Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Primarylogo.png?v=1741556234" },
      { name: "ADP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ADP_Crest_Color.png?v=1741556234" }
    ],
    colors: [
      { name: "Azure", code: "#0071CE" },
      { name: "Midnight", code: "#002D5C" },
      { name: "Adelphan Blue", code: "#7582BD" },
      { name: "Diamond", code: "#FFFFFF" },
      { name: "Horizon", code: "#DAE1E9" },
      { name: "Sand", code: "#CBC3BB" },
      { name: "Woodland Violet", code: "#C8B0C5" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "alpha-omicron-pi": {
    name: "Alpha Omicron Pi",
    logos: [
      { name: "AOP Tagline Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Logo_Tagline_Color.png?v=1741632939" },
      { name: "AOP Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Letters_RED.png?v=1741632939" },
      { name: "AOP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Letters_BLK.png?v=1741632939" },
      { name: "AOP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Letters_WHT.png?v=1741632939" },
      { name: "AOP Infinity Rose", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AOP_Infinity_Rose_Color.png?v=1741632939" }
    ],
    colors: [
      { name: "Ambitious Pink", code: "#EF436D" },
      { name: "Cardinal Red", code: "#C22032" },
      { name: "Confident Coral", code: "#E26E5C" },
      { name: "Promising Purple", code: "#724B55" },
      { name: "Arthritis Blue", code: "#0072A1" },
      { name: "Humble Gray", code: "#D8D9D6" },
      { name: "Barnard Blue", code: "#87B3D1" },
      { name: "Graduate Gray", code: "#565F5F" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "alpha-phi": {
    name: "Alpha Phi",
    logos: [
      { name: "AP Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Letters_RED.png?v=1741694298" },
      { name: "AP Traditional Wordmark", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Traditional_Wordmark.png?v=1741694298" },
      { name: "AP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Crest_Color.png?v=1741694298" },
      { name: "AP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Letters_WHT.png?v=1741694298" },
      { name: "AP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/AP_Letters_BLK.png?v=1741694298" }
    ],
    colors: [
      { name: "Bordeaux", code: "#7C1B31" },
      { name: "Berry", code: "#9B234B" },
      { name: "Rose", code: "#E7C2CC" },
      { name: "Blush", code: "#F4D3DA" },
      { name: "Steel Blue", code: "#5B7E8B" },
      { name: "Iceberg", code: "#A3BFC6" },
      { name: "Powder Blue", code: "#B9D0DB" },
      { name: "Fern", code: "#9B9F85" },
      { name: "Ivy", code: "#5D5E54" },
      { name: "Sand", code: "#D9C7B8" },
      { name: "Ivory", code: "#F2EFE9" },
      { name: "Silver", code: "#C3C2C0" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "alpha-tau-omega": {
    name: "Alpha Tau Omega",
    logos: [
      { name: "ATO Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Crest_Color.png?v=1742401368" },
      { name: "ATO Letter Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letter_Logo.png?v=1742401368" },
      { name: "ATO Letters GOLD", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letters_GOLD.png?v=1742401368" },
      { name: "ATO Letters BLU", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letters_BLU.png?v=1742401368" },
      { name: "ATO Letters BLK", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ATO_Letters_BLK.png?v=1742401368" }
    ],
    colors: [
      { name: "Azure", code: "#487FC0" },
      { name: "Old Gold", code: "#F2A533" },
      { name: "Dark Blue", code: "#2B4E9C" },
      { name: "Dark Gold", code: "#CF8F00" },
      { name: "Sky Blue", code: "#5091CD" },
      { name: "Yellow", code: "#FFED6C" },
      { name: "Evergreen", code: "#34543D" },
      { name: "White", code: "#FFFFFF" },
      { name: "Soft Gray", code: "#D2D4D9" },
      { name: "Night", code: "#2D2C2C" },
      { name: "Black", code: "#000000" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "beta-theta-pi": {
    name: "Beta Theta Pi",
    logos: [
      { name: "BTP Crest Colors", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/BTP_Crest_Colors.png?v=1742404137" },
      { name: "BTP Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/BTP_HorizontalLogo.png?v=1742404137" },
      { name: "BTP Letters Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/BTP_Letters_NVY.png?v=1742404137" }
    ],
    colors: [
      { name: "Pantone 294", code: "#002E6C" },
      { name: "Pantone 2945", code: "#004C97" },
      { name: "Pantone Process Blue", code: "#0085ca" },
      { name: "Pantone Cool Gray 1", code: "#d9d9d6" },
      { name: "Pantone 7621", code: "#ab2328" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "chi-omega": {
    name: "Chi Omega",
    logos: [
      { name: "CO Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_CoA_Color.png?v=1741728581" },
      { name: "CO Official Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Official_Logo_Color.png?v=1741728581" },
      { name: "CO Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_RED.png?v=1741728581" },
      { name: "CO Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_YLW.png?v=1741728581" },
      { name: "CO Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CO_Letters_WHT.png?v=1741728581" }
    ],
    colors: [
      { name: "Straw", code: "#EED484" },
      { name: "Cardinal", code: "#C8102E" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "delta-chi": {
    name: "Delta Chi",
    logos: [
      { name: "DC Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_CoA_Color.png?v=1742409573" },
      { name: "DC Vertical Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_VerticalLogo.png?v=1742409573" },
      { name: "DC Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_HorizontalLogo.png?v=1742409573" },
      { name: "DC Badge", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DC_Badge.png?v=1742409573" }
    ],
    colors: [
      { name: "Red", code: "#ca3d31" },
      { name: "Yellow", code: "#f1bd19" },
      { name: "Navy Blue", code: "#111375" },
      { name: "Bluish Gray", code: "#9fa4a7" },
      { name: "Beige", code: "#e7dbb4" },
      { name: "Orange", code: "#d17229" },
      { name: "Blue Green", code: "#00a98e" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "delta-delta-delta": {
    name: "Delta Delta Delta",
    logos: [
      { name: "DDD Vertical Logo (White)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CMYK_Tricon_Vertical_White_800x800_bb5c2677-9ef3-4390-8128-3959574eb566.png?v=1743086416" },
      { name: "DDD Horizontal Logo (White)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/CMYK_Tricon_Horizontal_White_2400x1200_5c35d4b4-093d-4874-9415-b4c917ebdd98.png?v=1743086416" }
    ],
    colors: [
      { name: "Cerulean Blue", code: "#0047BB" },
      { name: "Gold", code: "#F1C400" },
      { name: "Silver", code: "#9B9B9B" },
      { name: "Bright Blue", code: "#0C5DDE" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    borders: [
      { name: "Default Border", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DDD_Customizer_Border.svg?v=1743094036" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "delta-gamma": {
    name: "Delta Gamma",
    logos: [
      { name: "DG Brandmark Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_BLK.png?v=1741726787" },
      { name: "DG Brandmark Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_NVY.png?v=1741726787" },
      { name: "DG Brandmark Pink", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_PNK.png?v=1741726787" },
      { name: "DG Brandmark Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Brandmark_GLD.png?v=1741726787" },
      { name: "DG Primary Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Primary_Logo.png?v=1741726787" },
      { name: "DG Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DG_Crest_Color.png?v=1741726787" }
    ],
    colors: [
      { name: "DG Navy", code: "#003356" },
      { name: "DG Pink", code: "#F8BBC3" },
      { name: "Cable Bronze", code: "#BB8F52" },
      { name: "Paper White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "gamma-phi-beta": {
    name: "Gamma Phi Beta",
    logos: [
      { name: "GPB Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_CoA_Color.png?v=1741729853" },
      { name: "GPB Primary Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Primary_Logo_Color.png?v=1741729848" },
      { name: "GPB Primary Symbol (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Primary_Symbol_Color.png?v=1741729848" },
      { name: "GPB Letters Pink", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Letters_PNK.png?v=1741729843" },
      { name: "GPB Letters Gray", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Letters_GRY.png?v=1741729853" },
      { name: "GPB Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/GPB_Letters_BLK.png?v=1741729853" }
    ],
    colors: [
      { name: "Blush", code: "#F8B1AA" },
      { name: "A-La-Mode", code: "#A69895" },
      { name: "Once in a Blue Moon", code: "#7B9BA8" },
      { name: "Pearl", code: "#F1E8E3" },
      { name: "Brownstone", code: "#6B6058" },
      { name: "Carnation", code: "#E46274" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "kappa-alpha": {
    name: "Kappa Alpha",
    logos: [
      { name: "KA Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_Logo_CoA.png?v=1741005812" },
      { name: "KA Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersBlk.png?v=1741005812" },
      { name: "KA Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersRED.png?v=1741005812" },
      { name: "KA Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersYLW.png?v=1741005812" },
      { name: "KA Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KA_LettersWHT.png?v=1741005812" }
    ],
    colors: [
      { name: "Blood / Crimson", code: "#9d2235" },
      { name: "Treasure / Old Gold", code: "#eaaa00" },
      { name: "White", code: "#ffffff" },
      { name: "Black", code: "#000000" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "kappa-alpha-theta": {
    name: "Kappa Alpha Theta",
    logos: [
      { name: "KAT Vertical Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_VerticalLogo_Color.png?v=1741732087" },
      { name: "KAT Horizontal Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_HorizontalLogo_Color.png?v=1741732082" },
      { name: "KAT Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_CoA_Color.png?v=1741731975" },
      { name: "KAT Letters Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_Letters_GLD.png?v=1741731975" },
      { name: "KAT Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_Letters_BLK.png?v=1741731975" },
      { name: "KAT Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KAT_Letters_WHT.png?v=1741731975" }
    ],
    colors: [
      { name: "Theta Gold", code: "#DEC66A" },
      { name: "Theta Black", code: "#010101" },
      { name: "Tlam Pink", code: "#FBBFA6" },
      { name: "Asbury Blue", code: "#B8C9E1" },
      { name: "Pansy Leaf Green", code: "#4C7061" },
      { name: "Flying Kite Purple", code: "#3E3E6C" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "kappa-delta": {
    name: "Kappa Delta",
    logos: [
      { name: "KD Greek Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KD_Greek_Logo_Color.png?v=1741734974" },
      { name: "KD Primary Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KD_PrimaryLogo_Color.png?v=1741734974" },
      { name: "KD Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KD_Crest_Color.png?v=1741734974" }
    ],
    colors: [
      { name: "Kappa Delta Olive", code: "#8D9000" },
      { name: "Soft Gray", code: "#F0F1F3" },
      { name: "Pearl White", code: "#FBFEFF" },
      { name: "Dark Olive", code: "#476749" },
      { name: "Light Olive", code: "#F1F4E3" },
      { name: "Basil Burgundy", code: "#6F1834" },
      { name: "Active Pink", code: "#E83D64" },
      { name: "Blush Pink", code: "#FDE6E6" },
      { name: "Confident Coral", code: "#F89679" },
      { name: "Clover Clay", code: "#F6B39B" },
      { name: "Confident Peach", code: "#F5B29E" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "kappa-delta-rho": {
    name: "Kappa Delta Rho",
    logos: [
      { name: "KDR Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_CoA_Color.png?v=1742424176" },
      { name: "KDR Letters Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_Letters_NAVY.png?v=1742424175" },
      { name: "KDR Letters Orange", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_Letters_ORNG.png?v=1742424175" },
      { name: "KDR Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KDR_Letters_BLCK.png?v=1742424175" }
    ],
    colors: [
      { name: "Middlebury Blue", code: "#002E6D" },
      { name: "Princeton Orange", code: "#EE7623" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "kappa-kappa-gamma": {
    name: "Kappa Kappa Gamma",
    logos: [
      { name: "KKG Letters Fleur Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_Fleur_Color.png?v=1741735548" },
      { name: "KKG Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_YLW.png?v=1741735548" },
      { name: "KKG Letters Blue", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_BLU.png?v=1741735581" },
      { name: "KKG Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_Letters_BLK.png?v=1741735548" },
      { name: "KKG Coat of Arms Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KKG_CoA_Color.png?v=1741735548" }
    ],
    colors: [
      { name: "Kappa Blue", code: "#0060CE" },
      { name: "Gamma Blue", code: "#002D62" },
      { name: "Bright Blue", code: "#0C3F95" },
      { name: "Key Gold", code: "#D2B715" },
      { name: "Light Blue", code: "#C9E2EB" },
      { name: "Silver", code: "#A0A4AD" },
      { name: "Dark Silver", code: "#686D70" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "kappa-sigma": {
    name: "Kappa Sigma",
    logos: [
      { name: "KS Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Crest_Color.png?v=1742424944" },
      { name: "KS Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Logo_Tagline.png?v=1742424944" },
      { name: "KS Letters Green", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Letters_GRN.png?v=1742424944" },
      { name: "KS Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Letters_RED.png?v=1742424944" },
      { name: "KS Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/KS_Letters_BLCK.png?v=1742424944" }
    ],
    colors: [
      { name: "Red", code: "#BF0D3E" },
      { name: "Green", code: "#215732" },
      { name: "Gold", code: "#C99700" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "phi-delta-theta": {
    name: "Phi Delta Theta",
    logos: [
      { name: "Phi Delta Theta Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Delta_Theta_Logo.png?v=1741960718" }
    ],
    colors: [
      { name: "Navy", code: "#0D1433" },
      { name: "Blue", code: "#619DC7" },
      { name: "Light Blue", code: "#DDECF3" },
      { name: "Blue Gray", code: "#5B7E8B" },
      { name: "Gold", code: "#F2B100" },
      { name: "Gray", code: "#939597" },
      { name: "Red", code: "#C8102E" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "phi-gamma-delta": {
    name: "Phi Gamma Delta",
    logos: [
      { name: "PGD Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_Crest_Color.png?v=1742426031" },
      { name: "PGD Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_Logo_Tagline.png?v=1742426031" },
      { name: "PGD Diamond (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_Diamond_Color.png?v=1742426031" },
      { name: "PGD FIJI (Black)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_FIJI_BLCK.png?v=1742426031" },
      { name: "PGD FIJI (Purple)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_FIJI_PRPL.png?v=1742426031" },
      { name: "PGD FIJI (Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PGD_FIJI_GOLD.png?v=1742426030" }
    ],
    colors: [
      { name: "Purple", code: "#520975" },
      { name: "Yellow", code: "#cba900" },
      { name: "Gray", code: "#8e8e91" },
      { name: "Gold", code: "#9f8a48" },
      { name: "Red", code: "#f0492f" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "phi-kappa-theta": {
    name: "Phi Kappa Theta",
    logos: [
      { name: "PKT Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKT_Crest_Color.png?v=1742497364" },
      { name: "PKT Vertical (RGB)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi-Kappa-Theta-PKT_Vertical_RGB.png?v=1742497129" },
      { name: "PKT Horizontal (RGB)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi-Kappa-Theta-PKT_Horizontal_RGB.png?v=1742497129" },
      { name: "PKT Logo Mark (RGB)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi-Kappa-Theta-Phi_Kappa_Theta_Logo_Mark_RGB.png?v=1742497129" }
    ],
    colors: [
      { name: "Cardinal Purple Red", code: "#75140C" },
      { name: "Gold (Dark)", code: "#D6AD60" },
      { name: "White (Light)", code: "#F4F1EA" },
      { name: "Black", code: "#231F20" },
      { name: "Cardinal Purple", code: "#800000" },
      { name: "Gold (Bright)", code: "#FBD410" },
      { name: "White", code: "#FFFFFF" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "phi-mu": {
    name: "Phi Mu",
    logos: [
      { name: "Phi Mu Primary Logo (Horizontal)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Mu_PrimaryLogo_Horizontal.png?v=1743256687" },
      { name: "Phi Mu Letters (Pink)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Mu_Letters_PINK.png?v=1743256687" },
      { name: "Phi Mu Letters (Grey)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Phi_Mu_Letters_GREY.png?v=1743256772" }
    ],
    colors: [
      { name: "Carnation", code: "#F681A2" },
      { name: "Magnolia", code: "#F2B9D9" },
      { name: "Blush", code: "#F8B1BD" },
      { name: "Petal", code: "#F2CAD8" },
      { name: "Charcoal", code: "#4F4F4F" },
      { name: "Pewter", code: "#999999" },
      { name: "Granite", code: "#686868" },
      { name: "Marble", code: "#CCCCCC" },
      { name: "Wesleyan Purple", code: "#663399" },
      { name: "Citrus", code: "#FFD700" },
      { name: "Sunflower", code: "#FFD54F" },
      { name: "Midnight", code: "#003366" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "pi-beta-phi": {
    name: "Pi Beta Phi",
    logos: [
      { name: "PBP Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Crest_Color.png?v=1741735975" },
      { name: "PBP Primary Logo (White)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_WHT.png?v=1741735975" },
      { name: "PBP Primary Logo (Red)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_RED.png?v=1741735975" },
      { name: "PBP Primary Logo (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_Color.png?v=1741735975" },
      { name: "PBP Primary Logo (Black)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_BLK.png?v=1741735974" },
      { name: "PBP Primary Logo (Blue)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_PrimaryLogo_BLU.png?v=1741735975" },
      { name: "PBP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_WHT.png?v=1741735974" },
      { name: "PBP Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_RED.png?v=1741735974" },
      { name: "PBP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_BLK.png?v=1741735974" },
      { name: "PBP Letters Blue", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PBP_Letters_BLU.png?v=1741735974" }
    ],
    colors: [
      { name: "Silver Blue", code: "#DDE5ED" },
      { name: "Wine", code: "#8B1A6C" },
      { name: "Heritage Wine", code: "#904736" },
      { name: "Rose", code: "#E78A8E" },
      { name: "Heritage Gray", code: "#9B9B9B" },
      { name: "Dark Gray", code: "#686D70" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "pi-kappa-alpha": {
    name: "Pi Kappa Alpha",
    logos: [
      { name: "PKA Letters Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_LettersGold.png?v=1741202065" },
      { name: "PKA Pike Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_PikeGOLD.png?v=1741202065" },
      { name: "PKA Pike Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_PikeRED.png?v=1741202065" },
      { name: "PKA Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_LettersBLK.png?v=1741202065" },
      { name: "PKA Pike Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_PikeBLK.png?v=1741202065" },
      { name: "PKA Letters Red", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_LettersRED.png?v=1741202065" },
      { name: "PKA Coat of Arms", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/PKA_CoA.png?v=1741201745" }
    ],
    colors: [
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" },
      { name: "Garnet", code: "#79242F" },
      { name: "Gold", code: "#9E8959" },
      { name: "Brotherhood Burgundy", code: "#91324F" },
      { name: "Courageous Crimson", code: "#8B1B2E" },
      { name: "Memphis Brick", code: "#992F38" },
      { name: "Oak", code: "#4C4020" },
      { name: "Old Gold", code: "#A1884E" },
      { name: "True Gold", code: "#A47E2E" },
      { name: "Khaki Gold", code: "#CAB883" },
      { name: "Light Gold", code: "#E3D4B2" },
      { name: "Tillar Taupe", code: "#C7B299" },
      { name: "Slate", code: "#46494B" },
      { name: "Dagger Gray", code: "#4F5359" },
      { name: "King Steel", code: "#939597" },
      { name: "Shield Silver", code: "#B8B9BA" },
      { name: "Light Silver", code: "#D3D4D5" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "sigma-alpha-epsilon": {
    name: "Sigma Alpha Epsilon",
    logos: [
      { name: "SAE Crest (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SAE_Crest_Color.png?v=1742506845" },
      { name: "SAE Shield (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SAE_Shield_Color.png?v=1742506846" },
      { name: "SAE Primary Logo (Purple/Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Primary_Logo_Purple_Gold_Transparent.png?v=1742506731" },
      { name: "SAE Greek Logo (Purple)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Purple_Transparent.png?v=1742506731" },
      { name: "SAE Greek Logo (Purple/Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Purple_Gold_Transparent.png?v=1742506730" },
      { name: "SAE Greek Logo (Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Gold_Transparent.png?v=1742506731" },
      { name: "SAE Simplified Shield (Gold)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Simplified_Shield_Gold.png?v=1742506725" },
      { name: "SAE Simplified Shield (Purple)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Simplified_Shield_Purple.png?v=1742506725" },
      { name: "SAE Shield (Purple/Gold Transparent)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Shield_Purple_and_Gold_Transparent.png?v=1742506646" },
      { name: "SAE Greek Logo (Gold v2)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-SAE_Greek_Logo_Gold_Transparent.png?v=1742506642" },
      { name: "SAE Shield (Gold Transparent)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Sigma-Alpha-Epsilon-Shield_Gold_Transparent.png?v=1742506642" }
    ],
    colors: [
      { name: "SAE Gold (Primary)", code: "#F4BD1D" },
      { name: "SAE Purple (Primary)", code: "#6A498E" },
      { name: "SAE Black", code: "#000000" },
      { name: "SAE Gold (Secondary)", code: "#B37D38" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "sigma-chi": {
    name: "Sigma Chi",
    logos: [
      { name: "SC Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_CoA_Color.png?v=1742581655" },
      { name: "SC Shield Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Shield_Color.png?v=1742581654" },
      { name: "SC Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_BLK.png?v=1742582029" },
      { name: "SC Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_WHT.png?v=1742582029" },
      { name: "SC Letters Yellow", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_YLW.png?v=1742582029" },
      { name: "SC Letters Navy", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SC_Letters_NVY.png?v=1742582029" }
    ],
    colors: [
      { name: "Pantone 299 C", code: "#0c4bab" },
      { name: "Pantone 122 C", code: "#f1d10f" },
      { name: "Pantone 7406 C", code: "#fcd107" },
      { name: "Pantone 7546 C", code: "#1f1e1d" },
      { name: "Black", code: "#000000" },
      { name: "CEO Yellow", code: "#fcf000" },
      { name: "Pantone 874 C", code: "#85641e" },
      { name: "Pantone 2995 C", code: "#71c2db" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "sigma-kappa": {
    name: "Sigma Kappa",
    logos: [
      { name: "SK Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_Crest_Color.png?v=1742329741" },
      { name: "SK Logo Tagline", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_Logo_Tagline.png?v=1742329741" },
      { name: "SK Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SK_HorizontalLogo.png?v=1742329741" }
    ],
    colors: [
      { name: "Purple", code: "#441155" },
      { name: "Lavender", code: "#DECCE3" },
      { name: "Maroon", code: "#881133" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "sigma-nu": {
    name: "Sigma Nu",
    logos: [
      { name: "SN Coat of Arms (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SN_CoA_Color.png?v=1742584802" },
      { name: "SN Badge (Color)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/SN_Badge_Color.png?v=1742584802" },
      { name: "SN Letters (873C)", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/EN.png?v=1753380839" }
    ],
    colors: [
      { name: "PMS 108 U", code: "#FFC600" },
      { name: "PMS Black U2", code: "#231F20" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" },
      { name: "PMS 873 C", code: "#846E48" },
      { name: "PMS 404 U", code: "#615D59" },
      { name: "PMS 485 U", code: "#E45A4F" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "zeta-psi": {
    name: "Zeta Psi",
    logos: [
      { name: "Zeta Psi Escutcheon Full Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Zeta-Psi-Zeta_Psi_Escutcheon_Full_Color_7d701af0-4af0-4bb3-9c79-8ff858474c19.png?v=1742755393" },
      { name: "ZP Letters 2-Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_2Color.png?v=1742755392" },
      { name: "ZP Letters Gold", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_YLW.png?v=1742755392" },
      { name: "ZP Letters White", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_WHT.png?v=1742755392" },
      { name: "ZP Letters Black", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_Letters_BLCK.png?v=1742755392" },
      { name: "ZP Horizontal Logo", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZP_HorizontalLogo.png?v=1742755392" }
    ],
    colors: [
      { name: "Zeta Psi Gold", code: "#FFB300" },
      { name: "Pure White", code: "#FFFFFF" },
      { name: "Pure Black", code: "#000000" }
    ],
    // ← Add Zeta Psi’s full chapter list here:
    chapters: [
      { name: "Alpha Epsilon",   value: "Alpha Epsilon" },
      { name: "Alpha Mu",        value: "Alpha Mu" },
      { name: "Alpha Nu",        value: "Alpha Nu" },
      { name: "Alpha Pi",        value: "Alpha Pi" },
      { name: "Alpha Psi",       value: "Alpha Psi" },
      { name: "Alpha Sigma",     value: "Alpha Sigma" },
      { name: "Alpha Theta",     value: "Alpha Theta" },
      { name: "Beta",            value: "Beta" },
      { name: "Beta Delta",      value: "Beta Delta" },
      { name: "Beta Tau",        value: "Beta Tau" },
      { name: "Chi Gamma",       value: "Chi Gamma" },
      { name: "Chi Tau",         value: "Chi Tau" },
      { name: "Delta",           value: "Delta" },
      { name: "Delta Alpha",     value: "Delta Alpha" },
      { name: "Delta Chi",       value: "Delta Chi" },
      { name: "Delta Pi",        value: "Delta Pi" },
      { name: "Eta",             value: "Eta" },
      { name: "Gamma Epsilon",   value: "Gamma Epsilon" },
      { name: "Gamma Psi",       value: "Gamma Psi" },
      { name: "Iota",            value: "Iota" },
      { name: "Iota Alpha",      value: "Iota Alpha" },
      { name: "Iota Delta",      value: "Iota Delta" },
      { name: "Iota Nu",         value: "Iota Nu" },
      { name: "Iota Omicron",    value: "Iota Omicron" },
      { name: "Iota Pi",         value: "Iota Pi" },
      { name: "Kappa Alpha",     value: "Kappa Alpha" },
      { name: "Kappa Beta",      value: "Kappa Beta" },
      { name: "Kappa Delta",     value: "Kappa Delta" },
      { name: "Kappa Phi",       value: "Kappa Phi" },
      { name: "Mu Pi",           value: "Mu Pi" },
      { name: "Mu Theta",        value: "Mu Theta" },
      { name: "Nu",              value: "Nu" },
      { name: "Nu",              value: "Nu" },           // duplicate as provided
      { name: "Nu Delta",        value: "Nu Delta" },
      { name: "Omega Alpha",     value: "Omega Alpha" },
      { name: "Omicron",         value: "Omicron" },
      { name: "Omicron Epsilon", value: "Omicron Epsilon" },
      { name: "Phi",             value: "Phi" },
      { name: "Phi Epsilon",     value: "Phi Epsilon" },
      { name: "Phi Lambda",      value: "Phi Lambda" },
      { name: "Pi",              value: "Pi" },
      { name: "Pi Kappa",        value: "Pi Kappa" },
      { name: "Pi Sigma",        value: "Pi Sigma" },
      { name: "Pi Tau",          value: "Pi Tau" },
      { name: "Psi",             value: "Psi" },
      { name: "Psi Epsilon",     value: "Psi Epsilon" },
      { name: "Psi Omicron",     value: "Psi Omicron" },
      { name: "Rho Alpha",       value: "Rho Alpha" },
      { name: "Rho Tau",         value: "Rho Tau" },
      { name: "Sigma",           value: "Sigma" },
      { name: "Sigma Beta",      value: "Sigma Beta" },
      { name: "Tau",             value: "Tau" },
      { name: "Tau Gamma",       value: "Tau Gamma" },
      { name: "Tau Omicron",     value: "Tau Omicron" },
      { name: "Tau Theta",       value: "Tau Theta" },
      { name: "Theta",           value: "Theta" },
      { name: "Theta Eta",       value: "Theta Eta" },
      { name: "Theta Omicron",   value: "Theta Omicron" },
      { name: "Theta Phi",       value: "Theta Phi" },
      { name: "Theta Psi",       value: "Theta Psi" },
      { name: "Theta Xi",        value: "Theta Xi" },
      { name: "Upsilon",         value: "Upsilon" },
      { name: "Zeta Epsilon",    value: "Zeta Epsilon" },
      { name: "Zeta Tau",        value: "Zeta Tau" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  },
  "zeta-tau-alpha": {
    name: "Zeta Tau Alpha",
    logos: [
      { name: "ZTA Crest Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_Crest_Color.png?v=1742331498" },
      { name: "ZTA Primary Logo Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_PrimaryLogo_Color.png?v=1742331453" },
      { name: "ZTA Letters Logo Color", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_LettersLogo_Color.png?v=1742331453" },
      { name: "ZTA BLK Crown + Name", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_BLK_Crown_Name.png?v=1752261472" },
      { name: "ZTA WHT Crown + Name", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/ZTA_WHT_Crown_Name.png?v=1752261657" }
    ],
    colors: [
      { name: "Turquoise", code: "#00aea0" },
      { name: "Dark Gray", code: "#919693" },
      { name: "Light Gray", code: "#adafaa" },
      { name: "Hot Pink", code: "#e22882" },
      { name: "Black", code: "#000000" },
      { name: "White", code: "#ffffff" }
    ],
    customMessage: "Create Your Own Design & Save 20%!"
  }
};

// Default borders pool (used if no organization-specific override is provided)
const defaultBorders = [
  { name: "Default Border 1", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-01.svg?v=1743023473" },
  { name: "Default Border 2", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-02.svg?v=1743218932" },
  { name: "Default Border 3", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-03.svg?v=1743023473" },
  { name: "Default Border 4", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-04.svg?v=1743023473" },
  { name: "Default Border 5", file: "https://cdn.shopify.com/s/files/1/0840/7023/6464/files/Customizer_Border-05.svg?v=1743023473" }
];


/* CHUNK 2: UI Structure, Event Listeners, and Preview Updates */

document.getElementById("rug-customizer-container").innerHTML = `
  <!-- Make sure your <head> includes:
       <meta name="viewport" content="width=device-width, initial-scale=1" />
  -->

  <style>
    /* Base reset for responsive inputs */
    #rug-customizer-container input,
    #rug-customizer-container select,
    #rug-customizer-container textarea,
    #rug-customizer-container button {
      max-width: 100%;
      box-sizing: border-box;
    }

    /* When viewport is narrower than 640px: stack the two columns */
    @media (max-width: 640px) {
      #customizer-wrapper {
        flex-direction: column;
        gap: 20px;
      }
      #design-preview {
        width: 100% !important;
        height: auto !important;
        aspect-ratio: 3 / 2; /* maintain approximate aspect ratio */
      }
      #customizer-options {
        grid-template-columns: 1fr !important;
        gap: 10px !important;
      }
      #customizer-options label {
        display: block;
      }
      #price-estimate {
        font-size: 16px !important;
      }
      #submitDesign {
        width: 100%;
      }
    }
  </style>

  <div style="max-width:1200px; margin:0 auto;">
    <h2 id="customizer-title" style="text-align:center; font-size:36px; font-weight:bold; color:#3972ba; margin:10px 0;">
      Create Your Own Design & Save 20%!
    </h2>
    <div id="customizer-wrapper" style="display:flex; flex-direction:row; justify-content:center; align-items:start; gap:100px;">
      <div style="max-width:500px; margin:0 auto; text-align:center; flex:1;">
        <!-- Updated: remove fixed 600x400, use width:100%, max-width:600px, aspect-ratio:3/2 -->
        <div id="design-preview" style="position:relative; width:100%; max-width:600px; height:auto; aspect-ratio:3 / 2; background-color:white; display:flex; align-items:center; justify-content:center; margin:10px 0; border:0px solid transparent;">
          <span id="top-text" style="position:absolute; top:10%; width:100%; text-align:center; font-weight:bold;"></span>
          <span id="placeholder-text" style="color:#333; font-size:16px;">Your Design Here</span>
          <!-- Border preview container with inline SVG injection -->
          <div id="selectedBorderStyle" style="display:none; position:absolute; width:100%; height:100%; z-index:5; pointer-events:none;"></div>
          <img id="uploadedLogo" style="display:none; position:absolute; max-width:60%; max-height:60%; z-index:10;" />
          <span id="bottom-text" style="position:absolute; bottom:10%; width:100%; text-align:center; font-weight:bold;"></span>
        </div>
        <p style="font-style:italic; font-size:14px; color:#666; margin:2px 0;">
          Designs and/or color may change slightly to conform with manufacturer capabilities. 
          Want more colors or a chapter logo? Email <a href="mailto:Landon@greek-rugs.com">Landon@greek-rugs.com</a>.
        </p>
        <p style="font-style:italic; font-size:32px; color:#3972ba; margin-top:10px; margin-bottom:2px;"></p>
      </div>
      <div id="customizer-options" style="display:grid; grid-template-columns:1fr 1fr; gap:15px; max-width:600px; padding:15px; flex:1;">
        <label>Name: <input type="text" id="userNameInput" placeholder="Your Name"></label>
        <label>Email: <input type="email" id="userEmailInput" placeholder="Your Email"></label>
        <label>Product Type:
          <select id="productTypePicker">
            <option value="" selected>No Selection</option>
            <option value="2'x3' Entry Mat">2'x3' Entry Mat</option>
            <option value="3'x4' Entry Mat">3'x4' Entry Mat</option>
            <option value="4'x6' Entry Mat">4'x6' Entry Mat</option>
            <option value="4'x5' Area Rug">4'x5' Area Rug</option>
            <option value="5'x8' Area Rug">5'x8' Area Rug</option>
            <option value="8'x11' Area Rug">8'x11' Area Rug</option>
            <option value="Other">Other</option>
          </select>
        </label>
        <label>Base Color:
          <select id="baseColorPicker"><option value="">No Selection</option></select>
        </label>
        <label>Border Color:
          <select id="borderColorPicker"><option value="">No Selection</option></select>
        </label>
        <label>Choose Logo:
          <select id="logoPicker"><option value="">No Selection</option></select>
        </label>
        <!-- Border Style Dropdown -->
        <label>Border Style:
          <select id="borderStylePicker"><option value="">No Selection</option></select>
        </label>
        <label>Top Text: <input type="text" id="topTextInput" placeholder="Optional"></label>
        <label>Bottom Text: <input type="text" id="bottomTextInput" placeholder="Optional"></label>
        <label>Text Color:
          <select id="textColorPicker"><option value="">Default (Black)</option></select>
        </label>
        <label>Orientation:
          <select id="orientationPicker">
            <option value="horizontal" selected>Horizontal</option>
            <option value="vertical">Vertical</option>
          </select>
        </label>
        <label>Additional Requests: <textarea id="additionalRequestsInput" placeholder="Optional"></textarea></label>
        <!-- Chapter dropdown: hidden by default, shown/populated in loadOrganizationData() if orgData.chapters exists -->
        <label id="chapterContainer" style="display:none;">
          Zeta Psi Chapter:
          <select id="chapterPicker"><option value="">No Selection</option></select>
        </label>
        <p id="price-estimate" style="font-size:18px; font-weight:bold; text-align:center; grid-column:1 / span 2;">
          Estimated Total: $0.00
        </p>
        <p style="font-style:italic; font-size:14px; color:#666; text-align:center; margin:0; grid-column:1 / span 2;">
          Please allow a moment for logos to load. Note: Text shown in the preview is for placement only. 
          Final font style, size, and layout will be adjusted according to customer requests.
        </p>
        <button id="submitDesign" style="font-size:14px; padding:10px 20px; margin:10px auto; grid-column:1 / span 2; display:block;">Submit Design</button>
      </div>
    </div>
  </div>
`;

// Set minimal padding
document.getElementById("rug-customizer-container").style.padding = "0px 15px 0px 15px";

// -------------------------
// Function: loadOrganizationData
// -------------------------
function loadOrganizationData() {
  console.log("loadOrganizationData() called...");
  const urlParams = new URLSearchParams(window.location.search);
  let orgParam = urlParams.get("org");
  if (!orgParam) {
    const pathParts = window.location.pathname.split("/");
    const collectionsIndex = pathParts.indexOf("collections");
    if (collectionsIndex !== -1 && pathParts.length > collectionsIndex + 1) {
      orgParam = pathParts[collectionsIndex + 1];
    }
  }
  console.log("orgParam from URL:", orgParam);

  let orgKey = "";
  if (orgParam) {
    const lowerParam = orgParam.toLowerCase();
    for (let key in organizations) {
      if (key.toLowerCase() === lowerParam) {
        orgKey = key;
        break;
      }
    }
  }
  currentOrgKey = orgKey;

  // If we found a valid org in our 'organizations' object:
  if (orgKey && organizations.hasOwnProperty(orgKey)) {
    const orgData = organizations[orgKey];
    console.log("🔹 Detected orgKey:", orgKey);
    console.log("✅ Organization Loaded:", orgData);

    //
    // 1. Populate Base Color dropdown
    //
    const baseColorDropdown = document.getElementById("baseColorPicker");
    if (orgKey === "delta-delta-delta") {
      baseColorDropdown.innerHTML = `<option value="#0047BB" selected>Cerulean Blue</option>`;
    } else {
      baseColorDropdown.innerHTML = `
        <option value="">No Selection</option>
        ${orgData.colors
          .map(color => `<option value="${color.code}" style="background-color:${color.code};">${color.name}</option>`)
          .join("")}
      `;
    }

    //
    // 2. Populate Border Color dropdown
    //
    const borderColorDropdown = document.getElementById("borderColorPicker");
    borderColorDropdown.innerHTML = `
      <option value="">No Selection</option>
      ${orgData.colors
        .map(color => `<option value="${color.code}" style="background-color:${color.code};">${color.name}</option>`)
        .join("")}
    `;
    if (orgKey === "delta-delta-delta") {
      // Tri-Delta always uses white border by default:
      borderColorDropdown.innerHTML = `
        <option value="">No Selection</option>
        <option value="#ffffff" style="background-color:#ffffff;" selected>White</option>
      `;
      borderColorDropdown.value = "#ffffff";
    }

    //
    // 3. Populate Logo dropdown
    //
    const logoDropdown = document.getElementById("logoPicker");
    if (logoDropdown) {
      logoDropdown.innerHTML = `
        <option value="">No Selection</option>
        ${orgData.logos
          .map(logo => `<option value="${logo.file}">${logo.name}</option>`)
          .join("")}
      `;
    } else {
      console.error("❌ ERROR: Logo dropdown element not found.");
    }

    //
    // 4. Populate Border Style dropdown
    //    — Each <option>'s value must be the exact text ("Default Border 3"), so the Form prefill matches.
    //    — The actual SVG URL is stored in data-svg-url for live preview.
    //
    const borderStyleDropdown = document.getElementById("borderStylePicker");
    if (!borderStyleDropdown) {
      console.error("❌ ERROR: borderStylePicker element not found.");
    } else {
      if (orgKey === "delta-delta-delta") {
        // Tri-Delta has only one border choice
        borderStyleDropdown.innerHTML = `
          <option value="Default Border">Default Border</option>
        `;
      } else {
        // Use org-specific borders if they exist, otherwise defaultBorders
        const borders = (orgData.borders && orgData.borders.length)
          ? orgData.borders
          : defaultBorders;

        borderStyleDropdown.innerHTML = `
          <option value="">No Selection</option>
          ${borders
            .map(border => `
              <option 
                value="${border.name}" 
                data-svg-url="${border.file}"
              >${border.name}</option>
            `)
            .join("")}
        `;
      }
    }

    //
    // 5. Populate Text Color dropdown
    //
    const textColorDropdown = document.getElementById("textColorPicker");
    if (textColorDropdown) {
      textColorDropdown.innerHTML = `
        <option value="">Default (Black)</option>
        ${orgData.colors
          .map(color => `<option value="${color.code}" style="background-color:${color.code}; color:${color.code};">${color.name}</option>`)
          .join("")}
      `;
    } else {
      console.error("❌ ERROR: Text color dropdown element not found.");
    }

    //
    // 6. Populate Chapter dropdown (only if orgData.chapters exists)
    //
    const chapterContainer = document.getElementById("chapterContainer");
    const chapterPicker = document.getElementById("chapterPicker");
    if (Array.isArray(orgData.chapters) && orgData.chapters.length > 0) {
      chapterContainer.style.display = "block";
      chapterPicker.innerHTML = `
        <option value="">No Selection</option>
        ${orgData.chapters
          .map(chap => `<option value="${chap.value}">${chap.name}</option>`)
          .join("")}
      `;
    } else {
      chapterContainer.style.display = "none";
    }

  } else {
    //
    // If no valid org was found, blank-out every dropdown
    //
    console.warn(`No organization data found for orgParam: '${orgParam}'. Defaulting to empty selections.`);

    document.getElementById("baseColorPicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("borderColorPicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("logoPicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("borderStylePicker").innerHTML = `<option value="">No Selection</option>`;
    document.getElementById("textColorPicker").innerHTML = `<option value="">Default (Black)</option>`;

    // Hide chapter if there’s no orgData.chapters
    document.getElementById("chapterContainer").style.display = "none";
  }
}

// -------------------------
// Function: updatePreview
// -------------------------
function updatePreview() {
  console.log("updatePreview() called...");
  const preview = document.getElementById("design-preview");
  if (!preview) {
    console.warn("No preview element found!");
    return;
  }

  // 1. Handle orientation
  const orientationVal = document.getElementById("orientationPicker").value;
  // If viewport is small (mobile), we let the CSS aspect-ratio handle preview sizing.
  // Otherwise, fallback to fixed px.
  if (window.innerWidth > 640) {
    if (orientationVal === "vertical") {
      preview.style.width = "400px";
      preview.style.height = "600px";
    } else {
      preview.style.width = "600px";
      preview.style.height = "400px";
    }
  }

  // 2. Read all selected values
  const selectedBaseColor   = document.getElementById("baseColorPicker").value || "#ffffff";
  const selectedBorderColor = document.getElementById("borderColorPicker").value || "#000000";
  const uploadedLogo        = document.getElementById("logoPicker").value;
  const topText             = document.getElementById("topTextInput").value;
  const bottomText          = document.getElementById("bottomTextInput").value;
  const selectedTextColor   = document.getElementById("textColorPicker").value || "#000000";

  // 3. Update preview's background & border color
  preview.style.backgroundColor = selectedBaseColor;
  preview.style.borderColor     = selectedBorderColor;

  // 4. Draw topText / bottomText
  const topTextElem    = document.getElementById("top-text");
  const bottomTextElem = document.getElementById("bottom-text");
  topTextElem.textContent    = topText;
  bottomTextElem.textContent = bottomText;
  topTextElem.style.setProperty("color", selectedTextColor, "important");
  bottomTextElem.style.setProperty("color", selectedTextColor, "important");

  // 5. Show/hide the logo image or placeholder
  const placeholderTextElem = document.getElementById("placeholder-text");
  const logoImgElem         = document.getElementById("uploadedLogo");
  if (uploadedLogo) {
    logoImgElem.src           = uploadedLogo;
    logoImgElem.style.display = "block";
    placeholderTextElem.style.visibility = "hidden";
  } else {
    logoImgElem.style.display = "none";
    placeholderTextElem.style.visibility = "visible";
  }

  // 6. Handle Border Style preview
  const borderStyleSelect   = document.getElementById("borderStylePicker");
  const selectedOption      = borderStyleSelect.selectedOptions[0];
  const borderContainer     = document.getElementById("selectedBorderStyle");

  // If this is Tri-Delta & they chose "Default Border", use their special SVG
  if (currentOrgKey === "delta-delta-delta" && selectedOption && selectedOption.value === "Default Border") {
    if (orientationVal === "vertical") {
      borderContainer.innerHTML = `
        <img
          src="https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DDD_Customizer_Border_VERT.svg?v=1743103702"
          style="width:100%; height:100%;"
          alt="Tri-Delta Border"
        />
      `;
    } else {
      borderContainer.innerHTML = `
        <img
          src="https://cdn.shopify.com/s/files/1/0840/7023/6464/files/DDD_Customizer_Border.svg?v=1743094036"
          style="width:100%; height:100%;"
          alt="Tri-Delta Border"
        />
      `;
    }
    borderContainer.style.display = "block";
    return;
  }

  // Otherwise, if they chose a non‐empty "Border Style" (e.g. "Default Border 3"),
  // fetch the SVG from the data‐svg‐url attribute on that <option>.
  if (selectedOption && selectedOption.value) {
    const svgUrl = selectedOption.dataset.svgUrl;
    if (svgUrl) {
      fetch(svgUrl)
        .then(res => res.text())
        .then(svgText => {
          const parser = new DOMParser();
          const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
          const svgElem = svgDoc.documentElement;

          // Force fill to 100% & use currentColor
          svgElem.setAttribute("width", "100%");
          svgElem.setAttribute("height", "100%");
          svgElem.setAttribute("viewBox", "0 0 600 400");
          svgElem.setAttribute("preserveAspectRatio", "xMidYMid meet");
          svgElem.querySelectorAll("[fill]").forEach(el => el.setAttribute("fill", "currentColor"));
          svgElem.setAttribute("fill", "currentColor");

          // If vertical orientation, rotate and scale
          if (orientationVal === "vertical") {
            svgElem.setAttribute("transform", "rotate(90) scale(1.5)");
          } else {
            svgElem.removeAttribute("transform");
          }

          borderContainer.innerHTML = svgElem.outerHTML;
          borderContainer.style.display = "block";
          borderContainer.style.color = selectedBorderColor;
        })
        .catch(err => {
          console.error("Error fetching SVG:", err);
          borderContainer.innerHTML = "";
          borderContainer.style.display = "none";
        });
    } else {
      // If somehow the <option> had no data‐svg‐url, hide the border container entirely:
      borderContainer.innerHTML = "";
      borderContainer.style.display = "none";
    }
  } else {
    // No border‐style chosen → hide the border container
    borderContainer.innerHTML = "";
    borderContainer.style.display = "none";
  }
}

// -------------------------
// Function: setupEventListeners
// -------------------------
function setupEventListeners() {
  console.log("setupEventListeners() called...");
  document.getElementById("baseColorPicker").addEventListener("change", updatePreview);
  document.getElementById("borderColorPicker").addEventListener("change", updatePreview);
  document.getElementById("logoPicker").addEventListener("change", updatePreview);
  document.getElementById("topTextInput").addEventListener("input", updatePreview);
  document.getElementById("bottomTextInput").addEventListener("input", updatePreview);
  document.getElementById("textColorPicker").addEventListener("change", updatePreview);
  document.getElementById("orientationPicker").addEventListener("change", updatePreview);
  document.getElementById("productTypePicker").addEventListener("change", updatePriceEstimate);
  document.getElementById("borderStylePicker").addEventListener("change", updatePreview);
}

// -------------------------
// Function: updatePriceEstimate
// -------------------------
function updatePriceEstimate() {
  console.log("updatePriceEstimate() called...");
  const priceDisplay = document.getElementById("price-estimate");
  const productType = document.getElementById("productTypePicker").value;
  const productPrices = {
    "2'x3' Entry Mat": 69.00,
    "3'x4' Entry Mat": 149.00,
    "4'x6' Entry Mat": 239.00,
    "4'x5' Area Rug": 229.00,
    "5'x8' Area Rug": 389.00,
    "8'x11' Area Rug": 749.00,
    "Other": "Varies"
  };
  if (!productType || !(productType in productPrices)) {
    priceDisplay.textContent = "Estimated Total: Select a Product Type";
    return;
  }
  if (productPrices[productType] === "Varies") {
    priceDisplay.textContent = "Estimated Total: Varies (Contact for details)";
  } else {
    let basePrice  = productPrices[productType];
    let discount   = basePrice * 0.20;
    let finalPrice = basePrice - discount;
    priceDisplay.textContent =
      `Estimated Total: $${basePrice.toFixed(2)} - $${discount.toFixed(2)} = $${finalPrice.toFixed(2)} (Before Taxes & Custom Design Fee)`;
  }
}

// -------------------------
// Submission event
// -------------------------
document.getElementById("submitDesign").addEventListener("click", function () {
  console.log("submitDesign clicked...");
  const userName           = document.getElementById("userNameInput").value;
  const userEmail          = document.getElementById("userEmailInput").value;
  const productType        = document.getElementById("productTypePicker").value;
  const selectedBaseColor  = document.getElementById("baseColorPicker").value;
  const selectedBorderColor= document.getElementById("borderColorPicker").value;
  const uploadedLogo       = document.getElementById("logoPicker").value;
  const topText            = document.getElementById("topTextInput").value;
  const bottomText         = document.getElementById("bottomTextInput").value;
  const selectedTextColor  = document.getElementById("textColorPicker").value || "#000000";
  const isVertical         = (document.getElementById("orientationPicker").value === "vertical") ? "Vertical" : "Horizontal";
  const additionalRequests = document.getElementById("additionalRequestsInput").value;

  // 1. Border Style: get the exact radio label (e.g. "Default Border 3")
  const borderStyleSelect = document.getElementById("borderStylePicker");
  const selectedBorderOption = borderStyleSelect.selectedOptions[0];
  const selectedBorderName   = selectedBorderOption ? selectedBorderOption.value : "";

  // 2. Chapter (only if this org has chapters defined)
  let chapterPicked = "";
  const orgData = organizations[currentOrgKey];
  if (orgData && Array.isArray(orgData.chapters) && orgData.chapters.length > 0) {
    chapterPicked = document.getElementById("chapterPicker").value || "";
  }

  // 3. Build the prefill URL
  let submissionUrl =
    "https://docs.google.com/forms/d/e/1FAIpQLSdOxd7SofN5no7LrRWjZ3Ehs7qyz8jXGLdiLPn7YgKMYXCMBQ/viewform?usp=pp_url"
    // Name
    + `&entry.1436079684=${encodeURIComponent(userName)}`
    // Email
    + `&entry.2093363187=${encodeURIComponent(userEmail)}`
    // Product Type
    + `&entry.825667336=${encodeURIComponent(productType)}`
    // Base Color
    + `&entry.378756120=${encodeURIComponent(selectedBaseColor)}`
    // Border Style (must exactly match "Default Border 1", "Default Border 2", etc)
    + `&entry.1830382283=${encodeURIComponent(selectedBorderName)}`
    // Border Color
    + `&entry.1986364188=${encodeURIComponent(selectedBorderColor)}`
    // Logo URL
    + `&entry.1777811819=${encodeURIComponent(uploadedLogo)}`
    // Top Text
    + `&entry.292297435=${encodeURIComponent(topText)}`
    // Bottom Text
    + `&entry.10235251=${encodeURIComponent(bottomText)}`
    // Text Color
    + `&entry.681710926=${encodeURIComponent(selectedTextColor)}`
    // Orientation
    + `&entry.2026361460=${encodeURIComponent(isVertical)}`;

  // 4. Only append Chapter entry if this org actually has chapters defined
  if (chapterPicked) {
    submissionUrl += `&entry.1222824780=${encodeURIComponent(chapterPicked)}`;
  }

  // 5. Additional Requests
  submissionUrl += `&entry.1120034173=${encodeURIComponent(additionalRequests)}`;

  // 6. Open the Google Form in a new tab with all fields prefilled
  window.open(submissionUrl, "_blank");
});

// -------------------------
// Init Customizer
// -------------------------
function init() {
  console.log("init() called. Loading data, setting up listeners, and showing container...");
  loadOrganizationData();
  setupEventListeners();
  updatePreview();
  document.getElementById("rug-customizer-container").style.display = "block";
}

init();
